var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFunnelIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 13",
  fill: "currentColor",
  height: "1em",
  width: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0D4F78",
  fillRule: "evenodd",
  d: "M.67 0C.648 0 .63 0 .603.005H.6a.63.63 0 0 0-.585.479.625.625 0 0 0 .318.686l4.804 4.685v5.29a.628.628 0 0 0 .351.55l2.507 1.238c.2.097.432.088.62-.023a.623.623 0 0 0 .303-.527V5.826l4.847-4.723a.618.618 0 0 0 .233-.426.592.592 0 0 0-.153-.454V.218a.544.544 0 0 0-.198-.15c-.02-.01-.036-.02-.055-.025h-.005a.204.204 0 0 0-.054-.018h-.005c-.02-.01-.04-.01-.06-.015h-.005c-.02-.005-.04-.005-.065-.005C13.383 0 13.363 0 13.337 0c-.008 0-.018 0-.029.005H.734C.714 0 .689 0 .669 0z"
})));
export default SvgFunnelIconcom;